import { render, staticRenderFns } from "./UsersActivity.vue?vue&type=template&id=5c978106&"
import script from "./UsersActivity.vue?vue&type=script&lang=js&"
export * from "./UsersActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports